import { formatDate } from '@/utils/tool';
/*
  [30D  -  18Y]
     \     /
       \ /
       / \
     /     \
  [now-18Y，now-30D]
*/

export function getDate(diff, date = new Date()) {
  let [value, type] = diff;
  value = parseFloat(value);

  if (type && !Number.isNaN(value)) {
    if (type === 'Y') {
      date.setFullYear(date.getFullYear() - value);
    } else if (type === 'M') {
      date.setMonth(date.getMonth() - value);
    } else if (type === 'D') {
      date.setDate(date.getDate() - value);
    }

    date.setDate(date.getDate() - 1);
    return formatDate(date);
  }

  return undefined;
}
export function getDateRange(limit, min, max) {
  const ret = {
    min,
    max
  };

  if (limit) {
    const {
      begin,
      end
    } = limit;

    if (begin) {
      ret.max = getDate(begin);
    }

    if (end) {
      ret.min = getDate(end);
    }
  }

  return ret;
}
export function formatValue(value, fmt) {
  if (value instanceof Array) {
    return getDate(value) || '';
  }

  return formatDate(value, fmt);
}